import React from "react";
import IconButton from "@mui/material/IconButton";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { printBudgetGroupedPdf } from "../../utils/printBudgetPdf";

const BudgetPrintSelectionAgrupado = ({
  idsPresupuestos = [],
  proyectos = [],
  sx,
}) => {
  const handlePrint = async () => {
    if (!idsPresupuestos.length) return;
    try {
      await printBudgetGroupedPdf({ idsPresupuestos, proyectos });
    } catch (err) {
      console.error("Error al imprimir resumen de presupuestos:", err);
    }
  };

  return (
    <IconButton
      onClick={handlePrint}
      disabled={!idsPresupuestos.length}
      sx={sx}
    >
      <TableChartOutlinedIcon />
    </IconButton>
  );
};

export default BudgetPrintSelectionAgrupado;
